module.exports = __webpack_public_path__ + "static/media/success(1).861f581a.png";